// extracted by mini-css-extract-plugin
module.exports = {"content":"renew_content__10HAA","text":"renew_text__1EmVV","package":"renew_package__1qpHg","title":"renew_title__1vshF","subtext":"renew_subtext__1su8B"};